import React, { FunctionComponent, ReactElement } from "react";
import Button from "./Button";

interface PressDocumentProps {
  url: string;
  title: string;
}

const PressDocument: FunctionComponent<PressDocumentProps> = ({ url, title }): ReactElement => {
  return (
    <Button
      className="mx-1"
      href={url}
      title={title}
      target="_blank"
      color="primary"
    />
  )
}

export default PressDocument;
